module.exports = __webpack_public_path__ + "static/media/bike-cobra.c8daf3be.png";